/** Filtros de entrada alineados con las validaciones del backend (Auth.php). */

export function sanitizeAccount(value) {
  return String(value).toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 16);
}

export function sanitizePassword(value) {
  return String(value).replace(/[^a-zA-Z0-9]/g, "").slice(0, 16);
}

export function sanitizeSecretAnswer(value) {
  return String(value).replace(/[^\p{L}\p{N}\s]/gu, "").slice(0, 100);
}

export function sanitizeSecretQuestion(value) {
  return String(value).replace(/['"`;\\<>]/g, "").slice(0, 200);
}

export function sanitizeEmail(value) {
  return String(value).replace(/[\s'"<>;\\]/g, "").slice(0, 254);
}
